import { GroupSecurity } from '@quromedical/fhir-common';
import { WithGroup } from 'core/auth';
import { Section } from 'design-system';
import React from 'react';

interface MedicationHistoryProps {
  groups: GroupSecurity[];
  patientId: string;
  HistoryComponent: React.ComponentType<Pick<MedicationHistoryProps, 'patientId'>>;
}

export const MedicationHistory: React.FC<MedicationHistoryProps> = ({
  patientId,
  groups,
  HistoryComponent,
}) => {
  return (
    <WithGroup groups={groups}>
      <Section>
        <HistoryComponent patientId={patientId} />
      </Section>
    </WithGroup>
  );
};
